import { t } from 'i18next';
import { IoMdSettings } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { FilterIcon } from '../../../../../../assets/svg/filter';
import { SortIcon } from '../../../../../../assets/svg/sort';
import { Button } from '../../../../../../components/button/button';
import { DropdownFilter } from '../../../../../../features/dropdown-filter/dropdown-filter';
import { DropdownSorter } from '../../../../../../features/dropdown-sorter/dropdown-sorter';
import { DropdownStyleView } from '../../../../../../features/dropdown-style-view/dropdown-style-view';
import { HasAccess } from '../../../../../../features/has-access/has-access';
import { concatPath } from '../../../../../../helpers/path';
import { LeadesPath, ManagerPath, RootPath } from '../../../../../../routes/manager/manager-enums';
import { useLeadStore } from '../../../../../../store/use-lead-store';
import { ageOptions, getContentFieldValue, sexOptions } from '../../helpers';
import s from './leads-controls.module.css';

export const LeadsControls = () => {
  const { list } = useLeadStore();

  return (
    <div className={s.feature}>
      <DropdownStyleView />

      <DropdownSorter
        label={t('Сортировка')}
        leftIcon={<SortIcon />}
        options={[
          { label: t('Сначала новые'), value: 'created_at', dir: 'desc' },
          { label: t('Сначала старые'), value: 'created_at', dir: 'asc' },
        ]}
      />

      <DropdownFilter
        label={t('Фильтр')}
        leftIcon={<FilterIcon />}
        options={[
          {
            label: t('По ФИО'),
            value: 'name',
            filter: 'input',
            suggestions: list?.map((item) => getContentFieldValue(item, 'full_name')),
          },
          {
            label: t('По телефону'),
            value: 'phone',
            filter: 'input',
            suggestions: list?.map((item) => getContentFieldValue(item, 'phone')),
          },
          {
            label: t('По e-mail'),
            value: 'email',
            filter: 'input',
            suggestions: list?.map((item) => getContentFieldValue(item, 'email')),
          },
          {
            label: t('По полу'),
            value: 'sex',
            filter: 'single-select',
            filterOptions: sexOptions.map((item) => ({
              id: item.id,
              value: t(item.value),
            })),
          },
          {
            label: t('По возрасту'),
            value: 'age',
            filter: 'multi-select',
            filterOptions: ageOptions,
          },
          {
            label: t('По рейтингу'),
            value: 'rating',
            filter: 'input',
          },
          {
            label: t('По источнику'),
            value: 'source',
            filter: 'input',
          },
        ]}
      />

      <HasAccess service="lead" permissions={['write']}>
        <Link to={concatPath([RootPath.Manager, ManagerPath.Lead, LeadesPath.Config])}>
          <Button size="lg">
            <IoMdSettings />
            <span className="hide__M hide__S">{t('Настройки')}</span>
          </Button>
        </Link>
      </HasAccess>
    </div>
  );
};
